export const delayMS = async (ms: number) => new Promise(res => setTimeout(res, ms));